import { apiClient } from '../utils';


// Add New Tag (Special Service)
export const createTag = async (site, nm, idc, dc) => {
  const response = await apiClient.post('/merchant/service/createSpecialService', { data: { site, nm, idc, dc } });
  return response;
};



// List Tags (Special Service)

export const ListTags = async (site) => {
  const response = await apiClient.post('/merchant/service/getSpecialService', { data: { site } });
  return response;
};